const initialState = {
    adobeTesting: {
        adobeHasLoaded: false,
        adobeContentRenderingStart: false,
        adobeTestData: {
            tools: 'a',
            personalcode: 'a',
        },
        adobeExperiences: [] as Array<{
            testName: string;
            testVariant: string;
            testIsRedirect: boolean;
        }>,
    },
    personalCode: {
        errorType: '',
        modalOpen: false,
        modalInfo: {
            title: '',
            message: '',
        },
        redirectParams: {} as { type: string; target: string },
    },
    mobileNavMenuOpen: false,
    phoneMenuOpen: false,
    stickyGuideOpen: true,
    subMenuOpen: '' as ISubMenu,
    toggleActive: false,
    zipModalOpen: false,
};
export default initialState;
